import cn from 'classnames';
import { ptBrCommon } from '@/lib/pt-br/messages';
import { Image } from '@/components/ui/image';
import noResult from '@/assets/no-result.svg';
interface Props {
  text?: string;
  className?: string;
}

const NotFound: React.FC<Props> = ({ className, text }) => {
return (
    <div className={cn('flex flex-col items-center', className)}>
      <div className="w-full h-full flex items-center justify-center">
        <Image
          src={noResult}
          alt={text ? ptBrCommon(text) : "Nenhum Resultado Encontrado"}
          className="w-full h-full object-contain"
          unoptimized={true}
        />
      </div>
      {text && (
        <h3 className="w-full text-center text-xl font-semibold text-body my-7">
          {ptBrCommon(text)}
        </h3>
      )}
    </div>
  );
};

export default NotFound;
